module.exports = __webpack_public_path__ + "img/bitget.d5a68531.png";